export default "__VITE_ASSET__242aa382__"